import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

function SessionPopup({ show, handleClose, title, button,handleConfirm, initialValue = ''}) {
  const [inputValue, setInputValue] = useState(initialValue);
  const [request, setRequest] = useState(true);
  const [error, setError] = useState('');
  useEffect(() => {
    if (show) {
      setInputValue(initialValue);
      setError('');
    } else {
      setInputValue('');
    }
  }, [show, initialValue]);

  const handleSubmit = () => {
    handleConfirm(inputValue, setError);
    setRequest(false)
    // setInputValue('');
  };

  return (
    <Modal show={show} onHide={handleClose} centered backdrop="static">
      <Modal.Header style={{background:"#000",color:"#fff"}} closeButton closeVariant="white" >
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId="formSessionName">
          <Form.Label>Topic Name </Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter topic name"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            isInvalid={!!error}
          />
          <Form.Control.Feedback type="invalid">
            {error}
          </Form.Control.Feedback>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" disabled={!request}  onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="dark" disabled={!request} onClick={handleSubmit}>
          {!request ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Creating...
            </>
          ) : (
            button
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default SessionPopup;
